import React, { useRef, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  ButtonGroup,
  Dialog,
  InputLabel,
  List,
  ListItem,
  Paper,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  tooltipClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "../../../../styles/components/submissionUser.module.scss";
const dialogContainer = {
  [`.MuiDialog-container`]: {
    [`.MuiDialog-paper`]: {
      marginTop: "48px",
      boxShadow: "none",
      borderRadius: "10px !important",
      [`.MuiDialogContent-root`]: {
        padding: "0 11px",
      },
    },
  },
};
import PerfectScrollbar from "react-perfect-scrollbar";
import videoImage from "../../../../public/assets/images/videoPageImg.png";
import ManagerPendingVideoFeatured from "../../../ManagerPendingVideoFeatured/ManagerPendingVideoFeatured";
// import CopyIndexIcon from "../../../../public/assets/icons/CopyIndexIcon";
// import DownloadVideoIcon from "../../../../public/assets/icons/DownloadVideoIcon";
import CopyIndexIcon from "../../../../public/assets/icons/CopyIndexIcon";
import DownloadVideoIcon from "../../../../public/assets/icons/DownloadVideoIcon";
// import videoImage from '../../../../public/assets/images/videoPageImg.png'
import TextZoomIcon from "../../../../public/assets/icons/TextZoomIcon";
import VideoUrlIcon from "../../../../public/assets/icons/VideoUrlIcon";
import FileAttachIcon from "../../../../public/assets/icons/FileAttachIcon";
import Signature from "../../../../public/assets/images/signature.png";
import CopysubIcon from "../../../../public/assets/icons/CopysubIcon";

import MinimizeIcon from "../../../../public/assets/icons/MinimizeIcon";
import ExpandMoreIcon from "../../../../public/assets/icons/ExpandMoreIcon";
import CopyvsidIcon from "../../../../public/assets/icons/CopyvsidIcon";
import {
  getVideoDetails,
  updateDuplicateVideoDetails,
} from "../../../../api/functions/video.api";
import { useMutation, useQuery } from "react-query";
import HlsPalyer from "../HlsPlayer";
import {
  clipCopy,
  concatDownloadPath,
  concatHostAndVideoPath,
  openInNewTab,
  roleFinderTwo,
} from "../../../../lib/functions/utils.lib";
import ApiLoader from "../../../Loaders/ApiLoader";
import assest from "../../../../json/assest";
import VideoDetailsPending from "../VideoDetailsPending";
import SubmitterDetails from "../SubmitterDetails";
import CopyrightOwnerships from "../CopyrightOwnerships";
import SubmissionInformation from "../SubmissionInformation";
import CopyrightOwnershipsTwo from "../CopyrightOwnershipsTwo";
import { getCookie } from "../../../../lib/functions/storage.lib";

const OriginalVideoTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} followCursor />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    maxWidth: 237,
    borderRadius: "10px",
    color: "#000",
    boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
    padding: "9px 13px",
    [`& p`]: {
      color: "#000",
      fontSize: "12px",
      fontWeight: "500",
      lineHeight: "14px",
    },
  },
}));

const SocialVideoTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} followCursor />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    maxWidth: 237,
    borderRadius: "10px",
    color: "#000",
    boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
    padding: "9px 13px",
    [`& p`]: {
      color: "#000",
      fontSize: "12px",
      fontWeight: "500",
      lineHeight: "14px",
    },
  },
}));
const UpdateDuplicateVideoModal = ({
  open,
  onClose,
  id,
  video_id,
  refetchVideo,
}) => {
  console.warn("id", id, open);
  // const [copywriteHighlight, setCopywriteHighlight] = useState(true);
  const userCookie = getCookie("userdetails");
  let user = JSON.parse(userCookie ? userCookie : "{}");

  const { data, isLoading: isLoadingGet } = useQuery(
    ["video_details_duplication", id],
    async () => getVideoDetails(id, roleFinderTwo(user.role_id)),
    {
      enabled: id ? true : false,
      onSuccess: (data) => {
        console.warn("data2", data);
      },
    }
  );

  const { mutate, isLoading } = useMutation(updateDuplicateVideoDetails, {
    onSuccess: (data) => {
      console.warn("data", data);
      refetchVideo();
      onClose();
    },
    onError: (error) => {
      console.warn("error", error);
    },
  });

  const handleUpdate = (action) => {
    mutate({ video_id, match_id: id, matched: action });
  };

  return (
    <>
      <ApiLoader loading={isLoadingGet || isLoading} />

      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "89.688%",
            position: "relative",
            background: "#fff",
            marginTop: "35px !important",
          },
        }}
        sx={dialogContainer}
        className={`${styles.subUserInnermodal} ${styles.videoDetailsInModal}`}
      >
        <Box className={styles.pageCopyVideo}>
          {data && (
            <PerfectScrollbar className={styles.videoDetailsScroll}>
              <Box className={styles.pageCopyVideoBox}>
                <Stack
                  direction={"row"}
                  flexWrap={"wrap"}
                  className={styles.copywritterVideoWrapper}
                >
                  <Box className={styles.videoColLeft}>
                    <Paper className={styles.vdoCard}>
                      <Box
                        className={styles.videoBox}
                        // onClick={handleClickOpenProceed}
                      >
                        {/* <img src={videoImage} width={701} height={435} alt="" />
                      <ManagerPendingVideoFeatured /> */}
                        <HlsPalyer
                          source={concatHostAndVideoPath(data.converted_url)}
                        />
                      </Box>
                      <Box className={styles.videoInput}>
                        <input
                          type="text"
                          disabled
                          placeholder={concatDownloadPath(data.video)}
                        />
                        <Button
                          onClick={() =>
                            clipCopy(concatDownloadPath(data.video))
                          }
                        >
                          <img
                            src={assest.copyIcon}
                            width={13}
                            height={16}
                            alt=""
                          />
                        </Button>
                      </Box>
                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        flexWrap={"wrap"}
                        className={styles.vdoDesBtngrp}
                      >
                        <Button
                          onClick={() => handleUpdate("yes")}
                          className={styles.btnApprove}
                        >
                          Yes, The videos match
                        </Button>
                        <Button
                          onClick={() => handleUpdate("no")}
                          className={styles.btnReject}
                        >
                          {" "}
                          No, the videos are different
                        </Button>
                        <Box className={styles.downloadButton}>
                          <Button
                            onClick={() =>
                              openInNewTab(concatDownloadPath(data.video))
                            }
                          >
                            <img
                              src={assest.doenloadVideoicon}
                              width={13}
                              height={14}
                              alt=""
                            />{" "}
                            Download Video
                          </Button>
                        </Box>
                      </Stack>
                    </Paper>
                    <VideoDetailsPending
                      refetchVideo={refetchVideo}
                      data={data}
                    />
                  </Box>
                  <Box className={styles.videoColRight}>
                    <SubmitterDetails onClose={onClose} data={data} />
                    {/* <CopyrightOwnerships data={data} /> */}
                    <CopyrightOwnershipsTwo data={data} />
                    <SubmissionInformation data={data} />
                  </Box>
                </Stack>
              </Box>
            </PerfectScrollbar>
          )}
        </Box>
      </Dialog>
    </>
  );
};

export default UpdateDuplicateVideoModal;
